var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseCrossFillIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0007 28.3334L20.0007 22.3334L26.0007 28.3334L28.334 26L22.334 20L28.334 14L26.0007 11.6667L20.0007 17.6667L14.0007 11.6667L11.6673 14L17.6673 20L11.6673 26L14.0007 28.3334ZM20.0007 36.6667C17.6951 36.6667 15.5284 36.2289 13.5007 35.3534C11.4729 34.4778 9.70899 33.2906 8.20899 31.7917C6.70899 30.2928 5.52176 28.5289 4.64732 26.5C3.77288 24.4712 3.3351 22.3045 3.33399 20C3.33288 17.6956 3.77065 15.5289 4.64732 13.5C5.52399 11.4712 6.71121 9.70726 8.20899 8.20837C9.70676 6.70949 11.4707 5.52226 13.5007 4.64671C15.5307 3.77115 17.6973 3.33337 20.0007 3.33337C22.304 3.33337 24.4707 3.77115 26.5007 4.64671C28.5307 5.52226 30.2945 6.70949 31.7923 8.20837C33.2901 9.70726 34.4779 11.4712 35.3557 13.5C36.2334 15.5289 36.6707 17.6956 36.6673 20C36.664 22.3045 36.2262 24.4712 35.354 26.5C34.4818 28.5289 33.2945 30.2928 31.7923 31.7917C30.2901 33.2906 28.5262 34.4784 26.5007 35.355C24.4751 36.2317 22.3084 36.6689 20.0007 36.6667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCrossFillIcon);
export default __webpack_public_path__ + "static/media/close-cross-fill-icon.e130cff11bd898ed2e1286472168434c.svg";
export { ForwardRef as ReactComponent };